import {queryOptions} from '@tanstack/react-query'
import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchBasketPage from '~/client/sanity/fetchBasketPage'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 3 // 3h

const basketPageContentParams = z
    .object({
        locale: z.nativeEnum(Locale).optional(),
    })
    .optional()

export const getBasketPageContent = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = basketPageContentParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const {locale} = data ?? {}
        const basketPageContent = await fetchBasketPage(locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return basketPageContent
    })

export const basketPageContentQueryOptions = (locale: Locale = Locale.EnEu) =>
    queryOptions({
        queryKey: [locale, 'basketContent'],
        queryFn: () => getBasketPageContent({data: {locale}}),
        gcTime: 1000 * CACHE_TIME_SEC, // 3h
        staleTime: 1000 * CACHE_TIME_SEC, // 3h
    })
